export default {
  state: {
    status: []
  },
  getters: {
    getAppStatus: state => {
      return state.status
    }
  },
  mutations: {
    setStatus(state, payload) {
      state.status.push(payload)
    }
  },
  actions: {
    updateStatus(context, payload) {
      context.commit('setStatus', payload)
    }
  }
}
